/**
 * DE.FINE Collection — Quick Add
 * Vanilla JS, no dependencies. Delegated click listener for [data-dfc-quick-add].
 * Guarded against double-initialization across multiple section includes.
 */
(function () {
  if (window.__dfcQuickAdd) {
    return;
  }
  window.__dfcQuickAdd = true;

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setLabel(button, text) {
    if (!button.dataset.dfcOriginalLabel) {
      button.dataset.dfcOriginalLabel = button.textContent;
    }
    button.textContent = text;
  }

  function restoreLabel(button) {
    if (button.dataset.dfcOriginalLabel) {
      button.textContent = button.dataset.dfcOriginalLabel;
    }
  }

  function refreshCartCount() {
    fetch(getRoot() + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count;
        var selectors = [
          '.cart-count-bubble span[aria-hidden]',
          '[data-cart-count]',
          '.cart-count'
        ];
        selectors.forEach(function (selector) {
          document.querySelectorAll(selector).forEach(function (el) {
            el.textContent = count;
          });
        });
      })
      .catch(function () {
        /* silent — non-critical UI update */
      });
  }

  function tryOpenCartDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
        drawer.classList.add('is-open', 'open', 'active');
        return;
      }
    } catch (e) {
      /* guarded */
    }

    try {
      var notification = document.querySelector('cart-notification');
      if (notification) {
        if (typeof notification.renderContents === 'function') {
          fetch(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              notification.renderContents(cart);
            })
            .catch(function () {});
          return;
        }
        notification.classList.add('is-open', 'open', 'active');
      }
    } catch (e) {
      /* guarded — no drawer available, do nothing (no redirect) */
    }
  }

  function handleClick(event) {
    var button = event.target.closest('[data-dfc-quick-add]');
    if (!button) {
      return;
    }
    event.preventDefault();

    if (button.disabled || button.dataset.dfcLoading === 'true') {
      return;
    }

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }

    button.dataset.dfcLoading = 'true';
    setLabel(button, 'Adding…');

    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function () {
        setLabel(button, 'Added ✓');
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        tryOpenCartDrawer();

        setTimeout(function () {
          restoreLabel(button);
          button.dataset.dfcLoading = 'false';
        }, 1600);
      })
      .catch(function () {
        setLabel(button, 'Error — try again');
        setTimeout(function () {
          restoreLabel(button);
          button.dataset.dfcLoading = 'false';
        }, 2000);
      });
  }

  document.addEventListener('click', handleClick);
})();
